
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import BodyReport from "../pages/body-report/page";
import Revcella from "../pages/revcella/page";
import FitCarving from "../pages/fit-carving/page";
import Menu from "../pages/menu/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/body-report",
    element: <BodyReport />,
  },
  {
    path: "/revcella",
    element: <Revcella />,
  },
  {
    path: "/fit-carving",
    element: <FitCarving />,
  },
  {
    path: "/menu",
    element: <Menu />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
